import Input from "../../../../GlobalComponents/Input";
import { useTranslation } from "react-i18next";
import ContentHeader from "../../../../GlobalComponents/ContentHeader";
import ContentBody from "../../../../GlobalComponents/ContentBody";
import Loading from "../../../../GlobalComponents/Loading";
import { GetApolloErrorText } from "../../../../GlobalFunctions/helper";
import Error from "../../../../GlobalComponents/Error";
import { UseAuth } from "../../../Auth/Library/UseAuth";
import UseSendBulkPriceData from "../../Library/BulkPriceEdit/UseSendBulkPriceData";
import Select from "../../../../GlobalComponents/Select";
import RadioButton from "../../../../GlobalComponents/RadioButton";
import UseGetBulkPriceData from "../../Library/BulkPriceEdit/UseGetBulkPriceData";
import packageIcon from "../../../../Media/Images/Icons/package.webp";
import InputCard from "../../../../GlobalComponents/InputCard";
import List from "../../../../GlobalComponents/List/List";
import BulkPriceEditProgress from "./BulkPriceEditProgress";

const BulkPriceEdit = () => {
    const { user } = UseAuth();
    const { t } = useTranslation();

    const {
        loading,
        error,
        data,
        content,
        productLoading,
        productListHeaderData,
        loadCategoryProducts,
        loadManufacturersProducts,
        SelectAll,
        SelectRow,
        SetContent,
    } = UseGetBulkPriceData();
    const { formData, processingItems, SetFormData, SetCompleteFormData, StartBulkEdit } = UseSendBulkPriceData(
        user.lang,
        data?.AllLanguageMutations,
        SetContent
    );

    return (
        <>
            <ContentHeader title={t("BulkPriceEdit")} />
            <ContentBody>
                {error ? (
                    <Error text={GetApolloErrorText(error)} />
                ) : loading ? (
                    <Loading />
                ) : (
                    <>
                        {!formData.priceEditStarted ? (
                            <>
                                <div className="row flex-nowrap bulk-price-edit">
                                    <div className="col">
                                        <label className="input-label">{t("OperationType")}</label>
                                        <div className="form-group">
                                            <Select name="operationType" value={formData.operationType} OnChange={(e) => SetFormData(e)}>
                                                <option value="add">{t("IncreasePrice")}</option>
                                                <option value="sub">{t("DecreasePrice")}</option>
                                            </Select>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <label className="input-label">{t("ProductsFrom")}</label>
                                        <div className="form-group">
                                            <Select
                                                name="productSourceType"
                                                value={formData.productSourceType}
                                                OnChange={(e) => {
                                                    SetCompleteFormData({
                                                        ...formData,
                                                        productSourceType: e.target.value,
                                                        categoryID: 0,
                                                        subCategoryID: 0,
                                                        manufacturerID: 0,
                                                    });
                                                    SetContent([]);
                                                }}
                                            >
                                                <option value="manufacturer">{t("Manufacturer")}</option>
                                                <option value="category">{t("Category")}</option>
                                            </Select>
                                        </div>
                                    </div>
                                    {formData.productSourceType == "manufacturer" && (
                                        <div className="col">
                                            <label className="input-label">{t("Manufacturer")}</label>
                                            <div className="form-group">
                                                <Select
                                                    name="manufacturerID"
                                                    value={formData.manufacturerID}
                                                    OnChange={(e) => {
                                                        SetContent([]);
                                                        SetFormData(e);
                                                        loadManufacturersProducts(e.target.value);
                                                    }}
                                                >
                                                    <option value="add"> --{t("ChooseManufacturer")} --</option>
                                                    {data?.AllManufacturers.map((item) => (
                                                        <option key={item.manufacturerID} value={item.manufacturerID}>
                                                            {item.name}
                                                        </option>
                                                    ))}
                                                </Select>
                                            </div>
                                        </div>
                                    )}
                                    {formData.productSourceType == "category" && (
                                        <>
                                            <div className="col">
                                                <label className="input-label">{t("Category")}</label>
                                                <div className="form-group">
                                                    <Select
                                                        name="categoryID"
                                                        value={formData.categoryID}
                                                        OnChange={(e) => {
                                                            SetContent([]);
                                                            SetCompleteFormData({
                                                                ...formData,
                                                                categoryID: e.target.value,
                                                                subCategoryID: 0,
                                                                manufacturerID: 0,
                                                            });
                                                            loadCategoryProducts(e.target.value);
                                                        }}
                                                    >
                                                        <option value="add"> --{t("ChooseCategory")} --</option>
                                                        {data?.AllLinks.map((item) => (
                                                            <option key={item.linkID} value={item.linkID}>
                                                                {item.name}
                                                            </option>
                                                        ))}
                                                    </Select>
                                                </div>
                                            </div>
                                            {!!formData.categoryID && data?.AllLinks.find((cat) => cat.linkID == formData.categoryID)?.subLinks?.length > 0 && (
                                                <div className="col">
                                                    <label className="input-label">{t("SubCategory")}</label>
                                                    <div className="form-group">
                                                        <Select
                                                            name="subCategoryID"
                                                            value={formData.subCategoryID}
                                                            OnChange={(e) => {
                                                                SetContent([]);
                                                                SetFormData(e);
                                                                loadCategoryProducts(e.target.value);
                                                            }}
                                                        >
                                                            <option value="add"> --{t("ChooseSubCategory")} --</option>
                                                            {data?.AllLinks.find((cat) => cat.linkID == formData.categoryID)?.subLinks?.map((sub) => (
                                                                <option key={1000 * sub.linkID} value={sub.linkID}>
                                                                    {sub.name}
                                                                </option>
                                                            ))}
                                                        </Select>
                                                    </div>
                                                </div>
                                            )}
                                        </>
                                    )}
                                    <div className="col">
                                        <label className="input-label">{t("Price/Percent")}</label>
                                        <div className="form-group">
                                            <Input
                                                className="form-control"
                                                type="text"
                                                name="value"
                                                OnChange={(e) =>
                                                    SetCompleteFormData({ ...formData, value: { ...formData.value, [formData.selectedLang]: e.target.value } })
                                                }
                                                value={formData.value[formData.selectedLang]}
                                                append={`${formData.isPercentage == 1 ? "%" : `${formData.selectedLang == "sk" ? "€" : "Kč"}`}`}
                                            />

                                            <div className="bulk-val-languages">
                                                {data?.AllLanguageMutations.map((lang) => (
                                                    <span
                                                        key={lang.languageID}
                                                        className={`lang-button ${formData.selectedLang === lang.suffix ? "active" : ""}`}
                                                        onClick={() => SetFormData("selectedLang", lang.suffix)}
                                                    >
                                                        {lang.suffix}
                                                    </span>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <label className="input-label">&nbsp;</label>
                                        <div className="radio-container vertical">
                                            <RadioButton
                                                className="sm"
                                                name="isPercentage"
                                                checked={formData.isPercentage == 0}
                                                OnChange={(e) => SetFormData(e)}
                                                value={0}
                                                text={t("Amount")}
                                                id={"amount"}
                                            />
                                            <RadioButton
                                                className="sm"
                                                name="isPercentage"
                                                checked={formData.isPercentage == 1}
                                                OnChange={(e) => SetFormData(e)}
                                                value={1}
                                                text={t("Percent")}
                                                id={"percentage"}
                                            />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <label className="input-label">&nbsp;</label>
                                        <button
                                            className={`btn btn-primary`}
                                            onClick={() => {
                                                StartBulkEdit(content);
                                            }}
                                        >
                                            {t("Run")}
                                        </button>
                                    </div>
                                </div>

                                <InputCard title={t("ProductList")} icon={packageIcon} className={"form-group flex-1"} noBodyPadding={true}>
                                    <List
                                        headerData={productListHeaderData}
                                        headerClassName={"no-top-border"}
                                        contentData={content}
                                        isSortable={false}
                                        loading={productLoading}
                                        OnSelectAll={(e) => SelectAll(e)}
                                        colorLevels={true}
                                        hideOptions={true}
                                        options={{
                                            OnSelect: (e, rowData) => SelectRow(e, rowData.rowID),
                                        }}
                                    />
                                </InputCard>
                            </>
                        ) : (
                            <BulkPriceEditProgress
                                processingItems={processingItems}
                                OnClose={() => {
                                    SetFormData("priceEditStarted", false);
                                    SetContent([]);
                                    SetCompleteFormData({
                                        ...formData,
                                        categoryID: 0,
                                        subCategoryID: 0,
                                        manufacturerID: 0,
                                        value: {
                                            cz: "",
                                            sk: "",
                                        },
                                        priceEditStarted: false,
                                        selectedLang: "cz",
                                        isPercentage: 0,
                                    });
                                }}
                            />
                        )}
                    </>
                )}
            </ContentBody>
        </>
    );
};

export default BulkPriceEdit;
